const defaultSanitationOptions = {
    allowedTags: [
        "a",
        "b",
        "br",
        "em",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hr",
        "img",
        "li",
        "ol",
        "p",
        "span",
        "strong",
        "ul",
    ],
    allowedAttributes: {
        "a": ["href", "target", "rel"],
        "img": ["src", "alt", "height", "width"]
    },
    nonTextTags: [
        "button",
        "style",
        "script",
        "textarea",
        "option",
        "noscript",
        "xml"
    ],
    transformTags: {
        "h1" : "h2",
        "a": function (tagName, attribs) {
            let sanitizedAttributes = {};

            if(attribs.href) {
                sanitizedAttributes = {
                    target: "_blank",
                    rel: "noreferrer noopener",
                    href: attribs.href
                }
            }

            return {
                tagName: "a",
                attribs: sanitizedAttributes
            };
        }
    }
};

// Product descriptions are currently displayed within an iframe, so we can be a
// little less strict with the sanitization. Since ebay allows some fairly
// advanced customization, these looser restrictions improve compatibility.
const productDescriptionSanitationOptions = {
    allowedTags: [
        "a",
        "b",
        "br",
        "div",
        "em",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hr",
        "img",
        "li",
        "ol",
        "p",
        "span",
        "strong",
        "sub",
        "sup",
        "table",
        "thead",
        "tbody",
        "td",
        "th",
        "tr",
        "u",
        "ul",
        "style",
        "link",
        "iframe"
    ],
    allowedAttributes: {
        "*": ["class", "style", "id"],
        "a": ["href", "target", "rel"],
        "img": ["src", "alt", "style", "height", "width"],
        "iframe": ["src", "height", "width", "allowfullscreen", "frameborder"],
        "table": ["width", "height", "cellpadding", "border", "align", "valign"],
        "link": ["href", "rel", "type"]
    },
    allowedIframeHostnames: ["www.youtube.com"],
    allowIframeRelativeUrls: false,
    nonTextTags: [
        "button",
        "script",
        "textarea",
        "option",
        "noscript",
        "xml"
    ],
    transformTags: {
        "h1" : "h2",
        "object": (tagName, attribs) => {
            if (attribs.type !== "text/html") {
                return false;
            }

            return {
                tagName: "iframe",
                attribs: {
                    allowfullscreen: attribs.allowfullscreen,
                    width: attribs.width,
                    height: attribs.height,
                    frameborder: "0",
                    src: attribs.data,
                },
            }
        },
        "a": function (tagName, attribs) {
            let sanitizedAttributes = {};

            if(attribs.href && !/^#/.test(attribs.href)) {
                sanitizedAttributes = {
                    target: "_blank",
                    rel: "noreferrer noopener",
                    href: attribs.href
                }
            }

            return {
                tagName: "a",
                attribs: sanitizedAttributes
            };
        }
    }
};

module.exports = {
    defaultSanitationOptions,
    productDescriptionSanitationOptions
};
